import { render, staticRenderFns } from "./case-dashboard.vue?vue&type=template&id=8c4d8172&scoped=true"
import script from "./case-dashboard.vue?vue&type=script&lang=js"
export * from "./case-dashboard.vue?vue&type=script&lang=js"
import style0 from "./case-dashboard.vue?vue&type=style&index=0&id=8c4d8172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4d8172",
  null
  
)

export default component.exports